import { CAPTAIN_OPTION_1_INCLUDED_IN_PRICE, CAPTAIN_OPTION_2_INDEPENDENT_CAPTAIN } from 'src/common/constants';
import { formatDate } from 'src/common/utils/dateHelpers';
import { InquiryData } from 'src/inquiry/types';
import { TripCartFormState } from 'src/listing/types';

// eslint-disable-next-line import/prefer-default-export
export const mapFormStateToInquiryData = (state: TripCartFormState): InquiryData => {
  const {
    formSelectedDates,
    formDuration,
    formGuests,
    withCaptain,
    message,
    departureTime,
  } = state;
  const captainValue = Number(withCaptain);

  /**
   * TODO: Need to replace the hardcoded values with the actual values from the form
   */
  const mappedInquiry: InquiryData = {
    pickup_time: departureTime,
    preferred_date1: formatDate(formSelectedDates[0]),
    adults: formGuests,
    trip_length: formDuration,
    comment: message,
    captain_required: captainValue === CAPTAIN_OPTION_1_INCLUDED_IN_PRICE
    || captainValue === CAPTAIN_OPTION_2_INDEPENDENT_CAPTAIN,
  };

  return mappedInquiry;
};
